
    document.addEventListener("DOMContentLoaded", function () {
  // Sticky Search Button
  const stickySearchBtn = document.querySelector(".search_btn-nav");
  const headerSearchBtn = document.querySelector(".show-search-link");

  if (stickySearchBtn && headerSearchBtn) {
    stickySearchBtn.addEventListener("click", function () {
      headerSearchBtn.click(); // trigger header search
    });
  }

   const stickyFilterBtn = document.querySelector(".filter-btn_nav");
  const filterToggleBtn = document.querySelector(".toggle-btn");

  if (stickyFilterBtn && filterToggleBtn) {
    stickyFilterBtn.addEventListener("click", function () {
      filterToggleBtn.click(); // trigger header filter toggle
    });
  }
  const stickyCategoriesBtn = document.querySelector(".categories_btn_nav");
  const headerMenuBtn = document.querySelector(".mobile-nav-toggle");

  if (stickyCategoriesBtn && headerMenuBtn) {
    stickyCategoriesBtn.addEventListener("click", function () {
      headerMenuBtn.click(); // trigger header menu
    });
  }
});
